module.exports = __webpack_public_path__ + "img/edit.78392dcc.png";